import { render } from "./Package-edit.vue?vue&type=template&id=0a8d99d0&scoped=true"
import script from "./Package-edit.vue?vue&type=script&lang=js"
export * from "./Package-edit.vue?vue&type=script&lang=js"

import "./Package-edit.vue?vue&type=style&index=0&id=0a8d99d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8d99d0"]])

export default __exports__